import { useAsync } from "./useAsync";
import * as api from "../lib/api";

/** Fetch published News & Features items for the Our Story page. */
export function useNewsFeatures() {
  return useAsync(() => api.getNewsFeatures(), []);
}

/** Fetch all News & Features items including drafts (admin). */
export function useAdminNewsFeatures() {
  return useAsync(() => api.getAdminNewsFeatures(), []);
}
